import React from 'react';

import Alert, { AlertProps } from 'antd/es/alert';

import '@common/react/scss/components/expandedLegend.scss';

interface Props extends AlertProps {
	message: React.ReactNode;
	className?: string;
	isOpen?: boolean;
}

const ExpandedLegend: React.FC<Props> = ({
	className,
	isOpen = true,
	message,
	...props
}) => {
	return (
		<div className={`expanded-legend ${className || ''} ${isOpen ? 'expanded-legend__open' : ''}`}>
			<Alert
				type="info"
				showIcon
				title={message}
				{...props}
			/>
		</div>
	);
};

export default ExpandedLegend;
